<template>
  <div class="setup">
    <div class="setupCard"><slot /></div>
  </div>
</template>

<script setup lang="ts">
// The dialer's one focused card: a step or a pick list, centred on the pane it
// takes over. The slotted classes are its typography, so every card reads alike.
</script>

<style scoped>
/* The whole pane. Extra bottom padding lifts the card's centre by 5vh, to the optical
   centre rather than the geometric one; a taller card still scrolls from the top. */
.setup {
  flex: 1; min-width: 0; min-height: 0; overflow-y: auto; display: flex;
  padding: var(--space-6) var(--space-6) calc(var(--space-6) + 10vh); background: var(--color-bg-app);
}
.setupCard {
  width: 100%; max-width: 640px; margin: auto; box-sizing: border-box;
  background: var(--color-bg-surface); border: 1px solid var(--color-border-subtle); border-top: 6px solid var(--color-accent);
  border-radius: var(--radius-lg); box-shadow: var(--shadow-md); padding: var(--space-7);
  display: flex; flex-direction: column; gap: var(--space-5);
}
:slotted(.eyebrow) { font-size: var(--fs-xs); font-weight: var(--fw-semibold); letter-spacing: var(--tracking-wide); text-transform: uppercase; color: var(--color-text-tertiary); }
:slotted(.setupTitle) { margin: 0; font-family: var(--font-display); font-size: var(--fs-xl); font-weight: var(--fw-semibold); letter-spacing: var(--tracking-tight); line-height: var(--lh-tight); }
:slotted(.setupTitle:focus) { outline: none; }
:slotted(.setupCopy) { margin: 0; font-size: var(--fs-base); line-height: var(--lh-loose); color: var(--color-text-secondary); }
:slotted(.setupHint) { margin: 0; font-size: var(--fs-sm); line-height: var(--lh-normal); color: var(--color-text-tertiary); }
:slotted(.setupNote) { margin: 0; font-size: var(--fs-sm); line-height: var(--lh-loose); color: var(--color-text-secondary); }

:slotted(.actions) { display: flex; align-items: center; justify-content: flex-end; gap: var(--space-4); padding-top: var(--space-2); }
:slotted(.linkBtn) { border: 0; background: transparent; padding: 0; color: var(--color-text-tertiary); font-size: var(--fs-sm); cursor: pointer; text-decoration: underline; text-underline-offset: 3px; }
:slotted(.linkBtn:hover) { color: var(--color-text-secondary); }
:slotted(.linkBtn:disabled) { opacity: 0.55; cursor: default; }

:slotted(.failRow) { display: flex; align-items: center; gap: var(--space-3); padding: var(--space-3) var(--space-4); border-radius: var(--radius-md); background: var(--color-danger-soft); color: var(--color-danger); font-size: var(--fs-sm); }
</style>
